<section class="start-form-page" *ngIf="!success">

  <h1 class="title">Let's Start the<span class="accent">Conversation</span></h1>
  <p class="subtitle">Connect with us to explore how <strong>Gennius XYZ</strong> can support your <br> business with
    tailored loyalty & digital engagement solutions.</p>
  <div class="container card">
    <form [formGroup]="form" (ngSubmit)="submit()" class="form-grid">
      <div class="col">
        <label>First Name*</label>
        <input type="text" formControlName="firstName" [class.input-error]="isInvalid('firstName')" />
        <div class="error" *ngIf="isInvalid('firstName')">{{ getError('firstName') }}</div>
      </div>

      <div class="col">
        <label>Last Name*</label>
        <input type="text" formControlName="lastName" [class.input-error]="isInvalid('lastName')" />
        <div class="error" *ngIf="isInvalid('lastName')">{{ getError('lastName') }}</div>
      </div>

      <div class="col">
        <label>Business Email Address*</label>
        <input type="email" formControlName="email" [class.input-error]="isInvalid('email')" />
        <div class="error" *ngIf="isInvalid('email')">{{ getError('email') }}</div>
      </div>

      <div class="col">
        <label>Job title*</label>
        <input type="text" formControlName="jobTitle" [class.input-error]="isInvalid('jobTitle')" />
        <div class="error" *ngIf="isInvalid('jobTitle')">{{ getError('jobTitle') }}</div>
      </div>

      <div class="col">
        <label>Company*</label>
        <input type="text" formControlName="company" [class.input-error]="isInvalid('company')" />
        <div class="error" *ngIf="isInvalid('company')">{{ getError('company') }}</div>
      </div>

      <div class="col">
        <label>Country/Region*</label>
        <div class="select-wrap select_countrys">
          <!-- <select formControlName="country" [class.input-error]="isInvalid('country')">
            <option value="">Select</option>
            <option *ngFor="let s of companySizes" [value]="s">{{s}}</option>
          </select> -->

          <div class="container-input" id="container-countrie">
            <div class="select" [ngClass]="{'open': showOpenCountry}">
              <div class="head select_input" [ngClass]="{'input-error': isInvalid('country')}"
                (click)="showOpenCountries()">
                <div class="country">
                  <!-- <img src="./assets/img/backoffice/kingdom-flag.png" alt=""> -->

                  <ng-container *ngIf="countrySelect">
                    <img [src]="countrySelected?.country?.img | safeUrl"
                      [alt]="countrySelected?.country?.name + ' flag'">
                    {{ countrySelected?.country?.name }}
                  </ng-container>
                  <ng-container *ngIf="!countrySelect">
                    Select
                  </ng-container>
                </div>
                <span class="icon-arrow-black" (click)="showOpenCountries()"></span>
              </div>
              <div class="head head--open" *ngIf="showOpenCountry">
                <span class="icon-search"></span>
                <input type="text" #searchInput [value]="search" placeholder="Search"
                  (input)="search=searchInput.value">
                <span class="icon-close" (click)="search=''; searchInput.value=''; showOpenCountry=false"></span>
              </div>
              <div class="body" *ngIf="showOpenCountry">
                <div *ngFor="let country of countries | filterCountrie:search" class="radio-group"
                  (click)="selectCountry(country)">
                  <label class="country" [ngClass]="{'active': country?.name === form.get('country')?.value?.name}">
                    <!-- <input type="radio" formControlName="country" [value]="country"> -->
                    <img [src]="country?.img | safeUrl" [alt]="country?.name + ' flag'">
                    {{ country?.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="error" *ngIf="isInvalid('country')">{{ getError('country') }}</div>
      </div>

      <div class="col">
        <label>Type of Company*</label>
        <input type="text" formControlName="companyType" [class.input-error]="isInvalid('companyType')" />
        <div class="error" *ngIf="isInvalid('companyType')">{{ getError('companyType') }}</div>
      </div>

      <div class="col">
        <label>Company Size/Revenue*</label>
        <div class="select-wrap">
          <select formControlName="companySize" [class.input-error]="isInvalid('companySize')">
            <option value="">Select</option>
            <option *ngFor="let s of companySizes" [value]="s">{{s}}</option>
          </select>
        </div>
        <div class="error" *ngIf="isInvalid('companySize')">{{ getError('companySize') }}</div>
      </div>

      <div class="col message" style="grid-column: 1 / -1;">
        <label>Please tell us what you are interested in:</label>
        <textarea formControlName="message" rows="5"></textarea>
      </div>

      <div class="actions" style="grid-column: 1 / -1;">
        <button class="send-btn" type="submit">Send
          <img class="loader" src="./assets/img/gennius/load-spinner.gif" alt="" *ngIf="submitted">
        </button>
        <div class="error form-error" *ngIf="form.invalid && submitted">Please fix the errors above before sending.
        </div>
        <p class="privacy">We respect your privacy. Your information will only be used to provide relevant insights and
          solutions.</p>
      </div>
    </form>
  </div>
</section>


<section class="start-form-page start-form-page--touch" *ngIf="success">
  <div class="container card">
    <span>We’ll Be in Touch Soon</span>
    <div class="bubble">
      <img src="./assets/img/gennius/allex-icon.png" alt="">
      <div class="module">
        <p>Thank you, <strong>{{firstName}}</strong>. We’ll reach out shortly to explore new opportunities
          shaped for
          your business.</p>
      </div>
    </div>
    <button type="button" class="send-btn back" (click)="goBack()">Back
      <img class="loader" src="./assets/img/gennius/load-spinner.gif" alt="" *ngIf="submitted">
    </button>
  </div>
</section>


<app-footer></app-footer>